import { useState } from 'react';

export default function Golf() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const handleDownload = (fileId: string) => {
    window.open(`https://drive.google.com/uc?export=download&id=${fileId}`, '_blank');
  };

  const images = [
    {
      url: "https://i.imgur.com/WXug72F.jpg",
      alt: "Tecina Golf - Widok panoramiczny pola golfowego"
    },
    {
      url: "https://i.imgur.com/URNg3ko.jpg",
      alt: "Tecina Golf - Dołek z widokiem na ocean"
    },
    {
      url: "https://i.imgur.com/Rrx94I8.jpg",
      alt: "Tecina Golf - Fairway wśród natury"
    },
    {
      url: "https://i.imgur.com/n3tTIYA.jpg",
      alt: "Tecina Golf - Pole golfowe"
    },
    {
      url: "https://i.imgur.com/AluewDS.jpg",
      alt: "Tecina Golf - Spektakularne widoki"
    },
    {
      url: "https://i.imgur.com/4zHVwuA.jpg",
      alt: "Tecina Golf - Obiekty pola golfowego"
    },
    {
      url: "https://i.imgur.com/a4zCoc7.jpg",
      alt: "Tecina Golf - Panorama trasy"
    }
  ];

  return (
    <>
      <section id="golf" className="py-32 px-6 bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-green-200/20 rounded-full blur-3xl -z-10"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-emerald-200/20 rounded-full blur-3xl -z-10"></div>
        
        <div className="max-w-7xl mx-auto">
          {/* Header with impact question */}
          <div className="text-center mb-16">
            <div className="inline-block mb-6">
              <div className="flex items-center gap-3 bg-green-800 text-white px-6 py-2 rounded-full">
                <i className="ri-flag-line text-2xl"></i>
                <span className="text-sm font-medium uppercase tracking-wider">Tecina Golf Club</span>
              </div>
            </div>
            
            <h2 className="text-5xl md:text-6xl font-light text-stone-800 mb-6 leading-tight">
              Pole golfowe z najlepszymi<br />widokami na Wyspach Kanaryjskich?
            </h2>
            
            <div className="w-32 h-1 bg-gradient-to-r from-transparent via-green-600 to-transparent mx-auto mb-8"></div>
            
            <p className="text-2xl text-green-800 font-medium max-w-3xl mx-auto mb-4">
              Twoi klienci będą zachwyceni...
            </p>
            
            <p className="text-xl text-stone-600 max-w-4xl mx-auto leading-relaxed">
              18 dołków zaprojektowanych przez Donalda Steele, otoczonych subtropikalną roślinnością 
              z widokami na ocean Atlantycki i Teide (Teneryfa). Pole golfowe, które łączy wyzwanie 
              sportowe z doświadczeniem wizualnym, którego Twoi klienci nigdy nie zapomną.
            </p>
          </div>

          {/* Photo Gallery - 7 photos in creative layout */}
          <div className="grid grid-cols-12 gap-4 mb-16">
            {/* Large featured image - spans 8 columns, 2 rows */}
            <div 
              className="col-span-12 md:col-span-8 md:row-span-2 relative group overflow-hidden rounded-2xl shadow-2xl cursor-pointer"
              onClick={() => setSelectedImage(0)}
            >
              <div className="w-full h-[500px] md:h-[620px]">
                <img 
                  src={images[0].url}
                  alt={images[0].alt}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-6 left-6 text-white">
                  <i className="ri-zoom-in-line text-3xl"></i>
                </div>
              </div>
            </div>

            {/* Two medium images on the right - 4 columns each, 1 row */}
            {images.slice(1, 3).map((image, index) => (
              <div 
                key={index + 1}
                className="col-span-6 md:col-span-4 relative group overflow-hidden rounded-2xl shadow-xl cursor-pointer"
                onClick={() => setSelectedImage(index + 1)}
              >
                <div className="w-full h-[300px]">
                  <img 
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 text-white">
                    <i className="ri-zoom-in-line text-2xl"></i>
                  </div>
                </div>
              </div>
            ))}

            {/* Four small images - 3 columns each */}
            {images.slice(3).map((image, index) => (
              <div 
                key={index + 3}
                className="col-span-6 md:col-span-3 relative group overflow-hidden rounded-2xl shadow-xl cursor-pointer"
                onClick={() => setSelectedImage(index + 3)}
              >
                <div className="w-full h-[240px]">
                  <img 
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 text-white">
                    <i className="ri-zoom-in-line text-2xl"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mb-5">
                <i className="ri-flag-line text-green-700 text-3xl"></i>
              </div>
              <h4 className="text-xl font-semibold text-stone-800 mb-3">18 dołków wśród natury</h4>
              <p className="text-stone-600 leading-relaxed">
                Pole golfowe zaprojektowane przez Donalda Steele, otoczone subtropikalną roślinnością 
                z widokiem na Atlantyk i Teide. Każdy dołek oferuje unikalne wyzwanie i zapierające dech w piersiach widoki.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mb-5">
                <i className="ri-team-line text-blue-700 text-3xl"></i>
              </div>
              <h4 className="text-xl font-semibold text-stone-800 mb-3">Dla grup i indywidualistów</h4>
              <p className="text-stone-600 leading-relaxed">
                Idealne dla turniejów grupowych, programów incentive oraz indywidualnych graczy. 
                Profesjonalna obsługa i doskonałe warunki przez cały rok dzięki klimatowi subtropikalnemu.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mb-5">
                <i className="ri-gift-line text-amber-700 text-3xl"></i>
              </div>
              <h4 className="text-xl font-semibold text-stone-800 mb-3">Pakiety golfowe</h4>
              <p className="text-stone-600 leading-relaxed">
                Specjalne pakiety łączące pobyt w hotelu z grą w golfa. Atrakcyjne ceny dla grup, 
                długich pobytów i turniejów korporacyjnych. Możliwość personalizacji według potrzeb.
              </p>
            </div>
          </div>

          {/* Golf Course Highlights */}
          <div className="bg-gradient-to-r from-green-800 to-emerald-700 rounded-2xl p-12 text-white shadow-2xl mb-16">
            <h3 className="text-3xl font-light mb-8 text-center">
              Dlaczego Tecina Golf jest wyjątkowy?
            </h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Spektakularne widoki na Atlantyk i Teide</h5>
                  <p className="text-green-100 leading-relaxed">
                    Każdy dołek oferuje widoki na ocean Atlantycki i wulkan Teide na Teneryfie. 
                    Doświadczenie wizualne równie ważne jak sportowe.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Otwarte cały rok</h5>
                  <p className="text-green-100 leading-relaxed">
                    La Gomera ma wiosnę przez 365 dni w roku. Temperatury 20-25°C pozwalają grać 
                    w doskonałych warunkach o każdej porze.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Projekt Donalda Steela</h5>
                  <p className="text-green-100 leading-relaxed">
                    Zaprojektowane przez słynnego brytyjskiego architekta pól golfowych. 
                    Połączenie technicznego wyzwania z integracją w naturalny krajobraz.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Ekskluzywność i spokój</h5>
                  <p className="text-green-100 leading-relaxed">
                    Z dala od masowej turystyki. La Gomera to ukryty skarb Kanarów, 
                    co gwarantuje spokojną grę bez tłumów.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Blisko hotelu</h5>
                  <p className="text-green-100 leading-relaxed">
                    Pole golfowe jest częścią kompleksu Jardín Tecina. Twoi klienci mają wygodny dostęp 
                    z hotelu – maksymalna wygoda.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Club House & Pro Shop</h5>
                  <p className="text-green-100 leading-relaxed">
                    Nowoczesny club house z restauracją, pro shop i szatnią. Sala eventowa 
                    dla turniejów korporacyjnych znajduje się w hotelu.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* B2B Selling Points */}
          <div className="bg-white rounded-2xl p-10 shadow-xl border-2 border-green-200">
            <div className="flex items-start gap-6">
              <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                <i className="ri-lightbulb-line text-green-700 text-3xl"></i>
              </div>
              <div>
                <h4 className="text-2xl font-semibold text-stone-800 mb-4">
                  Argumenty sprzedażowe B2B
                </h4>
                <div className="space-y-3 text-stone-600 leading-relaxed">
                  <p className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-green-600 text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Unikalna oferta:</strong> jedyne pole golfowe na La Gomerze.</span>
                  </p>
                  <p className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-green-600 text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Widoki, które sprzedają:</strong> 18 dołków z widokiem na Atlantyk oraz Teneryfę i Teide (par 71 / 6 343 m).</span>
                  </p>
                  <p className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-green-600 text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Golf przez cały rok:</strong> możliwość sprzedaży 12 miesięcy w roku (zimą rekomendujemy wcześniejszą rezerwację; dostępność zawsze do potwierdzenia ze względu na turnieje).</span>
                  </p>
                  <p className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-green-600 text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Większa wartość rezerwacji:</strong> łatwe łączenie: hotel + golf + gastronomia + relaks.</span>
                  </p>
                  <p className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-green-600 text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Grupy i incentive:</strong> propozycje eventów/turniejów dla firm – na zapytanie (po potwierdzeniu dostępności).</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Tecina Golf Button */}
          <div className="text-center mt-12">
            <a 
              href="https://www.jardin-tecina.com/en/golf/" 
              target="_blank" 
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-3 bg-green-800 hover:bg-green-900 text-white px-10 py-4 rounded-full text-lg font-medium transition-colors whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
            >
              <i className="ri-golf-ball-line text-xl"></i>
              Więcej informacji – Tecina Golf
              <i className="ri-external-link-line text-lg"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage !== null && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-6"
          onClick={() => setSelectedImage(null)}
        >
          <button 
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
            onClick={() => setSelectedImage(null)}
          >
            <i className="ri-close-line text-3xl"></i>
          </button>
          
          <div className="max-w-6xl w-full">
            <img 
              src={images[selectedImage].url}
              alt={images[selectedImage].alt}
              className="w-full h-auto rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>

          {/* Navigation arrows */}
          {selectedImage > 0 && (
            <button
              className="absolute left-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImage(selectedImage - 1);
              }}
            >
              <i className="ri-arrow-left-line text-2xl"></i>
            </button>
          )}
          
          {selectedImage < images.length - 1 && (
            <button
              className="absolute right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImage(selectedImage + 1);
              }}
            >
              <i className="ri-arrow-right-line text-2xl"></i>
            </button>
          )}
        </div>
      )}
    </>
  );
}
